module.exports = __webpack_public_path__ + "static/img/quanliucheng_02.171bc74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quanliucheng_02.png
// module id = Ciin
// module chunks = 1